import { render, staticRenderFns } from "./ExpenseFlow.vue?vue&type=template&id=2c6951b6&scoped=true&"
import script from "./ExpenseFlow.vue?vue&type=script&lang=js&"
export * from "./ExpenseFlow.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseFlow.vue?vue&type=style&index=0&id=2c6951b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6951b6",
  null
  
)

component.options.__file = "ExpenseFlow.vue"
export default component.exports